export const TABLE_COLUMNS_NAMES = [
	{ dataIndex: 'id', title: '#', width: '180px', align: 'left' },
	{ dataIndex: 'name', title: 'Название' },
	{ dataIndex: 'icon', title: 'Иконка' },
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
